import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Link } from 'react-router-dom';
import AdminTableComponent from '../admin-table'
import { getListings } from '../actions';
import moment from 'moment'
import ListingActiveCell from './cell-renderers/listing-active-cell';
import ListingFeaturedCell from './cell-renderers/listing-featured-cell';
import ActionsCell from './cell-renderers/actions-cell';
import { getOrder } from '../bookings/bookings-list-component';

const shortDateFormat = "MM/DD/YY";
const longDateFormat = "MM/DD/YY hh:mm:ss";

const mapStateToProps = state => ({
  global: state.Global,
  listings: state.Admin.listings
});
const columns =
  [
    {
      Header: "Listing ID",
      accessor: "_id",
      Cell: ({ cell: { value } }) => (<Link to={`/listing/${value}`}>{value}</Link>),
      disableSortBy: true
    },
    {
      Header: "Name",
      accessor: "listingName",
      disableSortBy: true
    },
    {
      Header: "Owner",
      accessor: "fullOwnerAccessor",
      Cell: ({ data: listing }) => listing.fullOwnerName,
      CustomData: true
    },
    {
      Header: "Created\nDate",
      accessor: "rawCreatedDate",
      Cell: ({ data: listing }) => listing.niceCreatedDate,
      CustomData: true
    },
    {
      Header: "Location",
      accessor: "fullAddress"
    },
    {
      Header: "Published",
      accessor: "isActive",
      Cell: (props) => (<ListingActiveCell {...props} />),
      CustomData: true
    },
    {
      Header: "Featured",
      accessor: "isFeatured",
      Cell: (props) => (<ListingFeaturedCell {...props} />),
      CustomData: true
    },
    {
      Header: "View\nCount",
      accessor: "viewCount",
      Cell: ({ cell: { value } }) => !value ? 0 : value
    },
    {
      Header: "Last\nViewed\nOn",
      accessor: "rawLastViewedOn",
      Cell: ({ data: listing }) => listing.niceLastViewedOn,
      CustomData: true
    },
    {
      Header: " ",
      accessor: l => l._id,
      disableSortBy: true,
      Cell: (props) => (<ActionsCell {...props} />),
      CustomData: true,
    }
  ];


const sortTypes = {
  asc: {
    class: 'sort-up'
  },
  desc: {
    class: 'sort-down'
  },
  default: {
    class: 'sort'
  }
};

class ListingsListComponent extends PureComponent {
  constructor(props) {
    super(props);
  }

  state = {
    currentSort: 'desc',
    columnSorted: 'createdDate',
    dataType: 'date',
  };

  componentDidMount() {
    let { dispatch } = this.props;
    dispatch(getListings());
  }

  compareListings = (a, b) => {
    let { columnSorted } = this.state;
    let { currentSort } = this.state;
    let { dataType } = this.state;
    let dotCount = columnSorted.split(".").length - 1;

    // no periods between properties
    if (dotCount === 0) {
      let propertyA = a[columnSorted];
      let propertyB = b[columnSorted];

      return getOrder(propertyA, propertyB, currentSort, dataType);
    }
    // 1 period between properties
    else if (dotCount === 1) {
      let str1 = columnSorted.substring(0, columnSorted.indexOf('.'));
      let str2 = columnSorted.substring(columnSorted.indexOf('.') + 1);
      let propertyA = a[str1][str2];
      let propertyB = b[str1][str2];

      return getOrder(propertyA, propertyB, currentSort, dataType);
    }
    // 2 periods between properties
    else if (dotCount === 2) {
      let str1 = columnSorted.substring(0, columnSorted.indexOf('.'));
      let str2 = columnSorted.substring(columnSorted.indexOf('.') + 1, columnSorted.lastIndexOf('.'));
      let str3 = columnSorted.substring(columnSorted.lastIndexOf('.') + 1);
      let propertyA = a[str1][str2][str3];
      let propertyB = b[str1][str2][str3];

      return getOrder(propertyA, propertyB, currentSort, dataType);
    }

    return 0;
  }

  onSort = (column, type) => {
    const { currentSort } = this.state;
    const { columnSorted } = this.state;
    let nextSort;

    if (column === columnSorted) {
      if (currentSort === 'desc') nextSort = 'asc';
      else if (currentSort === 'asc') nextSort = 'desc';
      else if (currentSort === 'default') nextSort = 'desc';
      else nextSort = 'default';
    }
    else nextSort = 'desc';

    this.setState({
      currentSort: nextSort,
      columnSorted: column,
      dataType: type
    });
  }

  render() {
    let { listings } = this.props;
    let orderedListings = listings.map(l => {
      l.fullOwnerAccessor = l.userId ? `${l.userId.lastName} ${l.userId.firstName}` : ''
      l.fullOwnerName = l.userId ? `${l.userId.firstName} ${l.userId.lastName}` : ''
      l.fullAddress = `${l.address.city}, ${l.address.state}`;
      l.rawCreatedDate = moment(l.createdDate).valueOf();
      l.niceCreatedDate = moment(l.createdDate).format(shortDateFormat);
      l.rawLastViewedOn = (!l.lastViewedOn || l.lastViewedOn === "1900-01-01T05:00:00.000Z" || l.lastViewedOn === "01/01/1900")
        ? 0 : moment(l.lastViewedOn).valueOf();
      l.niceLastViewedOn = (!l.lastViewedOn || l.lastViewedOn === "1900-01-01T05:00:00.000Z" || l.lastViewedOn === "01/01/1900")
        ? "N/A" : moment(l.lastViewedOn).format(longDateFormat);
      return l;
    }).sort(this.compareListings);
    if (!listings) return (<div className="container text-center"><h4>Loading...</h4></div>)

    return (
      <AdminTableComponent columns={columns} data={orderedListings} />
    );

  }
}

export default withRouter(connect(mapStateToProps)(ListingsListComponent));
